{
  "name": "demf-data-discovery",
  "version": "3.1.4",
  "description": "Search for datasets and open data resources on the web",
  "private": false,
  "type": "module",
  "engines": {
    "node": ">=22.0.0 <23 || >=24.8.0 <25"
  },
  "scripts": {
    "predev": "node ./scripts/generate-vuetify-locales.mjs",
    "dev": "concurrently \"vite build --watch --mode development\" \"vite preview --port 9014\"",
    "prebuild": "node ./scripts/generate-vuetify-locales.mjs",
    "build": "vite build",
    "preview": "vite preview",
    "lint": "eslint . --fix",
    "format": "prettier --write src/"
  },
  "dependencies": {
    "@mdi/font": "^7.4.47",
    "axios": "^1.18.1",
    "pinia": "^3.0.4",
    "single-spa-vue": "^3.0.1",
    "vue": "^3.5.39",
    "vue-i18n": "^11.4.6",
    "vue-router": "^5.1.0",
    "vuetify": "^3.12.8"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@vitejs/plugin-vue": "^6.0.7",
    "@vue/eslint-config-prettier": "^10.2.0",
    "concurrently": "^9.2.3",
    "eslint": "^10.6.0",
    "eslint-plugin-vue": "^10.9.2",
    "globals": "^17.7.0",
    "prettier": "^3.9.4",
    "vite": "^8.1.3",
    "vite-plugin-css-injected-by-js": "^5.0.1"
  }
}
